import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_RIGHTS_DAT_SUCCESS = 'FETCH_RIGHTS_DAT_SUCCESS';
export const FETCH_RIGHTS_JSON_SUCCESS = 'FETCH_RIGHTS_JSON_SUCCESS';

export const fetchRightsDat = () =>
  network.actionWrapper(
      `${config.getApiUrl()}/rights.dat`,
      {
          begin: ACTION_BEGIN,
          success: FETCH_RIGHTS_DAT_SUCCESS,
          failure: ACTION_FAILURE,
      });

export const fetchRightsJson = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/rights.json`,
        {
          begin: ACTION_BEGIN,
          success: FETCH_RIGHTS_JSON_SUCCESS,
          failure: ACTION_FAILURE,
        });
